module.exports = __webpack_public_path__ + "static/f2-1fafbfe248651a2ba853501ef217f6a5.jpg";